export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-68f6e89b7a930349fba4f19e1023de4d.png";